import { render, staticRenderFns } from "./StartGridsPrint.vue?vue&type=template&id=352be8b6&scoped=true&"
import script from "./StartGridsPrint.vue?vue&type=script&lang=js&"
export * from "./StartGridsPrint.vue?vue&type=script&lang=js&"
import style0 from "./StartGridsPrint.vue?vue&type=style&index=0&id=352be8b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352be8b6",
  null
  
)

export default component.exports